import { ReactNode, useEffect } from 'react';
import ReactDOM from 'react-dom';

import './Modal.scss';

type Props = {
  show: boolean;
  onClose?: () => void;
  children: ReactNode;
};

const Modal = ({ children, onClose, show }: Props) => {
  useEffect(() => {
    const { document } = window;

    if (show) {
      document.body.style.height = '100vh';
      document.body.style.overflowY = 'hidden';
      document.body.style.paddingRight = '5px';
    } else {
      setTimeout(() => {
        document.body.style.height = 'initial';
        document.body.style.overflowY = 'initial';
        document.body.style.paddingRight = '';
      }, 100);
    }
  }, [show]);

  return ReactDOM.createPortal(
    <div className={`modal ${show ? 'show-modal' : ''}`} onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        {children}
      </div>
    </div>,
    document.getElementById('root')!
  );
};

export default Modal;
